<script>
    export default {
        data(){
            return {
                title:"",
                body:""
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/create/FundraiserCreatePage.vue